
import {Component, Prop, Vue} from "vue-property-decorator";
import HeaderBox from "@/components/query/dialogs/HeaderBox.vue";
import MessageBox from "@/components/query/dialogs/MessageBox.vue";

@Component({
  components: {HeaderBox, MessageBox}
})
export default class QueryConfirmDialog extends Vue {
  @Prop() confirmText!: string;
  @Prop() queryId!: string;

  get headline() {
    return "Query " + this.confirmText;
  }

  get text() {
    return "Möchten Sie Query " + this.queryId  + " wirklich auf \"" + this.confirmText + "\" setzen und speichern?";
  }
}
